export const iconFontAwesomeArrowsArrowUp = (
	<i className="fa-solid fa-arrow-up"></i>
);
